import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent}  from './app.component';

import { 
  
  WelcomeComponent,
  ProfileComponent,
  VersionsCrudComponent,
  ActionsCrudComponent,
  RolesCrudComponent,
  UsersCrudComponent,
  PermissionsCrudComponent,
  AuthoritiesCrudComponent,
  PersonsCrudComponent,
  VehiclesTypesCrudComponent,
  VehiclesStatusCrudComponent,
  DepositsCrudComponent,
  VehiclesCrudComponent,
  CranesCrudComponent,
  PersonsOperatorsCrudComponent,
  ServicesCrudComponent,  
  PaymentsTypesCrudComponent,
  ServicesStatusCrudComponent,
  ExpensesTypesCrudComponent,
  ExpensesCrudComponent,
  CustomersCrudComponent,
  CreditsCrudComponent,
  AccountsCrudComponent,
  ReceiptsCrudComponent

   } from '@app/admin';

import { LoginComponent } from '@app/login';

import { AuthGuard, LoginGuard } from '@app/core/guards';


const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'welcome',
    component: WelcomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'versions',
    component: VersionsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'actions',
    component: ActionsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'roles',
    component: RolesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'permissions',
    component: PermissionsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'users',
    component: UsersCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'authorities',
    component: AuthoritiesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'persons',
    component: PersonsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'persons_operators',
    component: PersonsOperatorsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vehicles_types',
    component: VehiclesTypesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vehicles_status',
    component: VehiclesStatusCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'deposits',
    component: DepositsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cranes',
    component: CranesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vehicles',
    component: VehiclesCrudComponent,
    canActivate: [AuthGuard]
  },   
  {
    path: 'services',
    component: ServicesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'payments_types',
    component: PaymentsTypesCrudComponent,
    canActivate: [AuthGuard]
  },  
  {
    path: 'services_status',
    component: ServicesStatusCrudComponent,
    canActivate: [AuthGuard]
  },  
  {
    path: 'expenses_types',
    component: ExpensesTypesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'expenses',
    component: ExpensesCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customers',
    component: CustomersCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'credits',
    component: CreditsCrudComponent,
    data: {status: 'ALL', title: 'Créditos'},
    canActivate: [AuthGuard]
  },
  {
    path: 'credits_pending',
    component: CreditsCrudComponent,
    data: {status: 'PENDING', title: 'Créditos pendientes'},
    canActivate: [AuthGuard]
  },
  {
    path: 'credits_paid',
    component: CreditsCrudComponent,
    data: {status: 'PAID', title: 'Créditos pagados'},
    canActivate: [AuthGuard]
  },
  {
    path: 'accounts',
    component: AccountsCrudComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'receipts',
    component: ReceiptsCrudComponent,
    canActivate: [AuthGuard]
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
